import React, { useEffect, useState } from 'react';

export default function Offcanvas({ id, title }) {
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('AV_User_Data'));

        if (title === "Privacy Policy") {
            setUrl('https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/PrivacyPolicy.html?service=amazingvideos');
        }

        if (title === "Terms & Conditions") {
            setUrl('https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/Terms%26Conditions.html?service=amazingvideos');
        }

        if (title === "My Account") {
            setUrl(`https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${user.billingChannelId}&MSISDN=${user.phone}&langCode=en`);
        }

        if (title === "Subscription Information") {
            setUrl(`https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${user.billingChannelId}&MSISDN=${user.phone}&langCode=en`);
        }

        setLoading(true); // Start loading when URL changes
    }, [title]);

    return (
        <div className="offcanvas offcanvas-end" tabIndex="-1" id={id} aria-labelledby={`${id}Label`}>
            <div className="offcanvas-header">
                <h5 id={`${id}Label`}>{title}</h5>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body position-relative" style={{ minHeight: '300px' }}>
                {loading && (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 start-0 bg-white" style={{ zIndex: 1 }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
                <iframe
                    src={url}
                    width="100%"
                    height="100%"
                    style={{ border: 'none', visibility: loading ? 'hidden' : 'visible' }}
                    onLoad={() => setLoading(false)}
                ></iframe>
            </div>
        </div>
    );
}
